import { ref, computed, watch } from 'vue';
import { defineStore } from 'pinia';

export const useProductListingStore = defineStore('product-listing', () => {

  const selectedOptions = ref([]);
  const selectedSortOrder = ref();
  const productCount = ref();
  const keywords = ref('');
  const tweakwiseFilterOptionsRestoredFromUrl = ref(false);
  const tweakwiseActive = ref(false);

  // Detect filter change
  watch(selectedOptions, (newValue, oldValue) => {
    if (newValue !== oldValue) {
      // listener in categories_listing.js
      General.dispatchGlobalEvent('vendreUpdateProductListingQueryParams', queryParams.value);
    }
  });

  // Detect sort change
  watch(selectedSortOrder, (newValue, oldValue) => {
    if (newValue !== oldValue) {
      // listener in categories_listing.js
      General.dispatchGlobalEvent('vendreUpdateProductListingQueryParams', queryParams.value);
    }
  });

  function addSortingParameters(urlSearchParams) {
    if (selectedSortOrder.value) {
      let sortValue = selectedSortOrder.value.value;
      let sortOrder = selectedSortOrder.value.order;

      if (tweakwiseActive.value) {
        if (urlSearchParams.has('tweakwise[sort_fields]')) {
          urlSearchParams.set('tweakwise[sort_fields]', sortValue);
        } else {
          urlSearchParams.append('tweakwise[sort_fields]', sortValue);
        }
      } else {
        if (urlSearchParams.has('sort_order')) {
          urlSearchParams.set('sort_order', sortOrder);
        } else {
          urlSearchParams.append('sort_order', sortOrder);
        }
  
        if (urlSearchParams.has('sort_by')) {
          urlSearchParams.set('sort_by', sortValue);
        } else {
          urlSearchParams.append('sort_by', sortValue);
        }
      }
    }
    return urlSearchParams;
  }
  
  const queryParams = computed(() => {
    let filterSearchParams = new URLSearchParams();

    for (let i = 0; i < selectedOptions.value.length; i++) {
      if (selectedOptions.value[i].id == 'price' ) {
        filterSearchParams.append(
          decodeURI("filter[price][min]"),
          selectedOptions.value[i].settings.minVal
        );
        filterSearchParams.append(
          decodeURI("filter[price][max]"),
          selectedOptions.value[i].settings.maxVal
        );
      } else {
        filterSearchParams.append(
          selectedOptions.value[i].settings.name, 
          selectedOptions.value[i].settings.value
        );
      }
    }
    
    // Add keywords (used in search results page)
    if (keywords.value) {
      filterSearchParams.append('keywords', keywords.value);
    }

    filterSearchParams = addSortingParameters(filterSearchParams);
    return filterSearchParams;
  });

  return {
    selectedSortOrder,
    productCount,
    selectedOptions,
    keywords,
    queryParams,
    tweakwiseFilterOptionsRestoredFromUrl,
    tweakwiseActive
  };
});